import { render, staticRenderFns } from "./TasksDetailed.vue?vue&type=template&id=5b70bc6c&scoped=true&"
import script from "./TasksDetailed.vue?vue&type=script&lang=js&"
export * from "./TasksDetailed.vue?vue&type=script&lang=js&"
import style0 from "./TasksDetailed.vue?vue&type=style&index=0&id=5b70bc6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b70bc6c",
  null
  
)

export default component.exports